import React from 'react';
import Header from '../components/Header';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const ContactUsPage = () => {
  return (
    <div className="ContactUsPage bg-[#f2f4f7]">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <ContactUs />
        <Footer />
      </div>
    </div>
  );
};

export default ContactUsPage;

